export default {
  notSupported: 'Recipe management is not available for this furnace type.',
};
